<template>
  <InputBox class="dates-input-box" icon="calendar" :label="label" @click="clicked">
    <template slot="value">
      <span @click.stop="clicked('start')" :class="{
        'dates-input-box__start': true,
        'dates-input-box__start--active': (highlight == 'start' || highlight == 'date' || highlight == 'month') }">
        {{ start }}
      </span>
      <span @click.stop="clicked('end')" :class="{
        'dates-input-box__end': true,
        'dates-input-box__end--active': highlight == 'end' }">
        {{ end }}
      </span>
    </template>
    <slot />
  </InputBox>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import InputBox from '@/components/search/InputBox'

@Component({
  components: {
    InputBox,
  },
  props: {
    label: {
      type: String,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
    highlight: {
      type: String, // One of [ 'start', 'end', 'date' ]
      required: false,
      default: () => 'start',
    },
  },
})
export default class DatesInputBox extends Vue {
  clicked (element) {
    log.debug('DatesInputBox.clicked', element)
    if (element === 'field') {
      // The rest of the field
      this.$emit('click', 'start')
    } else if (element === 'icon') {
      // Icon
      this.$emit('click', 'start')
    } else {
      this.$emit('click', element)
    }
  }
}
</script>

<style lang="scss">
.dates-input-box {

  &__start, &__end {
    text-transform: capitalize;

    &--active {
      color: #A0D5FF;
      border-left: 1px solid transparent;
      animation: PulseAttention 1s cubic-bezier(0, 1, 0, 1) forwards infinite;
    }
  }

  &__end {
    margin-left: 3px;
  }
}

@keyframes PulseAttention {
  50% {
    border-left-color: white;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DatesInputBox.vue